import { FaTrash } from "react-icons/fa";

const AdminImageCard = ({
    handleImageDelete,
    id,
    imageUrl,
    title,
    alt,
    date,
    time,
}) => {
    return (
        <div
            className="card has-background-info-light"
            style={{ width: "100%", textAlign: "center" }}
        >
            <div className="card-image">
                <figure className="image is-square">
                    <img
                        style={{
                            width: "100%",
                            objectFit: "scale-down",
                        }}
                        src={imageUrl}
                        alt="Resource"
                    />
                </figure>
            </div>

            <div className="card-content">
                <div className="media">
                    <div className="media-content">
                        <h1 className="title is-4">{title}</h1>
                        <p className="subtitle">{alt}</p>
                        <p>{date}</p>
                        {/* this was supposed to be in the backend what is happening? */}
                        <p>{time}</p>
                    </div>
                </div>
            </div>
            <footer className="card-footer">
                <button
                    className="button card-footer-item"
                    onClick={() => handleImageDelete(id)}
                >
                    <FaTrash color="tomato" />
                </button>
            </footer>
        </div>
    );
};

export default AdminImageCard;
